<template>
    <div class="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(15rem,1fr))]">
        <NewHomeCard
            v-for="card in cards"
            :key="card.title"
            class="h-full"
            :card-type="card.type"
            :title="card.title"
            :subtitle="card.subtitle"
            :content="card.content"
            :cta-button-text="card.ctaButtonText"
            @cta-click="$emit('cta-click', card)">
            <template #header>
                <img v-if="card.image_url" :src="card.image_url" :alt="card.title || 'Card'" class="h-10 w-auto object-contain max-w-50" />
                <img
                    v-else-if="organizationDetails?.logo_url"
                    :src="organizationDetails.logo_url"
                    :alt="organizationDetails.name || 'Organization logo'"
                    class="h-10 w-auto object-contain max-w-50" />
                <i v-else class="bi bi-people text-3xl/none" aria-hidden="true"></i>
            </template>
        </NewHomeCard>
    </div>
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import NewHomeCard from "~vue/ChatHome/NewHomeCard.vue";
import type { HomeCard, OrganizationPrompt, OrganizationSuggestedTopic } from "~vue/types/chat_home";
import { CARD_TYPE } from "~vue/utils/homeCards";
import { computed, type ComputedRef, inject, type Ref } from "vue";

interface Props {
    prompts?: OrganizationPrompt[];
    suggestedTopics?: OrganizationSuggestedTopic[];
}

const props = withDefaults(defineProps<Props>(), {
    prompts: () => [],
    suggestedTopics: () => [],
});

defineEmits(["cta-click"]);

const organizationDetails = inject<Ref<OrganizationDetails>>("organization_details");

const cards: ComputedRef<HomeCard[]> = computed(() => {
    const trendingTopics = props.prompts.map((prompt) => ({
        type: CARD_TYPE.ORGANIZATION,
        subtitle: undefined,
        title: prompt.title ?? prompt.external_name,
        external_name: prompt.external_name,
        source: "organization_prompt",
        content: prompt.description ?? undefined,
        ctaButtonText: "Start conversation",
        url: prompt.start_url,
        image_url: prompt.image_url ?? null,
        organizationPrompt: prompt,
    }));
    const suggestedTopics = props.suggestedTopics.map((topic) => ({
        type: CARD_TYPE.ORGANIZATION,
        subtitle: undefined,
        title: topic.title ?? topic.external_name,
        source: "organization_topic",
        content: topic.content,
        ctaButtonText: topic.copy || "Start conversation",
        url: topic.start_url,
        organizationTopic: topic,
        image_url: null,
    }));
    return [...trendingTopics, ...suggestedTopics];
});
</script>
